<div class="header-container">
  <div class="img-container">
    <a routerLink="/"><img src="./assets/images/Lagerlogo24_Wiki_farbig.png" class="logo"></a>
    <div class="titlediv">
      <h1 class="jubla-font">Wiki und die Starken JTBler</h1>      
    </div>
  </div>
</div>

<div class="mobile-menu" *ngIf="isMobile">
  <ul>
    <li><a routerLink="/">Home</a></li>
    <li><a routerLink="/images">Bilder</a></li>
    <li><a routerLink="/infos">Lagerinfos</a></li>
  </ul>
</div>

<div class="nav-buttons" *ngIf="!isMobile">
  <app-nav-bar-button title="Home" link="/"></app-nav-bar-button>
  <app-nav-bar-button title="Bilder" link="/images"></app-nav-bar-button>
  <app-nav-bar-button title="Lagerinfos" link="/infos"></app-nav-bar-button>
</div>
